




























import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Comments, { ResourceType } from "@/store/modules/Comments";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";

@Component({
    components: {}
})
export default class CommentBadge extends Vue {

    @Prop()
    name: string;

    @Prop()
    decisionId: string;

    @Prop()
    resource: {
        id: string | 'CONTENT',
        name?: string,
        type: ResourceType
    };

    @Prop()
    secondaryResource: {
        id: string | "WEIGHT",
        name?: string,
        type: ResourceType
    };

    @Prop()
    tertiaryResource: {
        id: string,
        name?: string,
        type: ResourceType
    };

    @Prop()
    hoverValue!: boolean;

    get hasThread() {
        return getModule(Comments).commentThreads.hasOwnProperty(this.commentResourceId);
    }

    get commentResourceId() {
        return Comments.generateId(this.resource.id, this.secondaryResource.id, this.tertiaryResource.id);
    }

    get isSelected() {
        return getModule(Comments).selectedCommentResourceId === this.commentResourceId;
    }

    get icon() {
        if (this.hasThread) {
            return "mdi-message-text"
        }
        return "mdi-message-plus-outline"
    }

    get color() {
        if (this.isSelected) {
            return "primary elevation-4"
        }
        if (this.hasThread) {
            return "var(--vp--primary)"
        }
        return "grey"
    }

    private selectBadge() {
        if (this.isSelected && getModule(WorkspaceOptions).openRight) {
            getModule(WorkspaceOptions).setOpenRight(false)
        } else {
            getModule(WorkspaceOptions).setActiveFocus({viewpointId: this.resource.id, choiceId: this.secondaryResource.id, factorId: this.tertiaryResource.id })
            getModule(WorkspaceOptions).setOpenRight(true)
        }
    }
}
